<template>
    <div>
      <div style="width:100%;height:99px;"></div>
      <div class="head-rows">
        <el-row class="head-row-bg" justify="center">
            <el-col :span="6" class="text-align" @click="gotoPage('/',0)">
              <el-image class="head-logo" alt="Vue logo" :src="logoSrc" fit="contain" />
              <p class="logo-title">LIFSONG</p>
            </el-col>
            <el-col :span="18" class="head-menus">
              <div class="head-menu">
                <div :class="isActive == 0?'head-menu-item head-menu-item-active':'head-menu-item'" @click="gotoPage('/',0)">
                  <div class="title">{{ $t('header.home') }}</div>
                </div>
                <div :class="isActive == 1?'head-menu-item head-menu-item-active':'head-menu-item'" @click="gotoPage('/hhb',1)">
                  <div class="title">{{ $t('header.vitalqi_series') }}</div>
                </div>
                <div :class="isActive == 1?'head-menu-item head-menu-item-active':'head-menu-item'" @click="gotoPage('/mms',4)">
                  <div class="title">{{ $t('mms.title') }}</div>
                </div>
                <div :class="isActive == 2?'head-menu-item head-menu-item-active':'head-menu-item'" @click="gotoPage('/breeze',2)" @mouseenter="handleMouseEnter('breeze')">
                  <div class="title" v-html="$t('header.breeze_series')"></div>
                </div>
                <div :class="isActive == 3?'head-menu-item head-menu-item-active':'head-menu-item'" @click="gotoPage('/about',3)" @mouseenter="handleMouseEnter('about')">
                  <div class="title">{{ $t('header.about_us') }}</div>
                </div>
                <!-- 语言切换：中 -->
                <div class="head-menu-item lang-switch" @click="toggleLang" v-if="locale !== 'zh'">
                  <div
                    class="title"
                    style="border: 1px solid #fff; padding: 5px 10px; border-radius: 4px;"
                  >
                    中文
                    <!--{{ locale === 'zh' ? 'EN' : '中文' }}-->
                  </div>
                </div>
                <!-- 语言切换：英 -->
                <div class="head-menu-item lang-switch" @click="toggleLang2" v-if="locale !== 'en'">
                  <div
                    class="title"
                    style="border: 1px solid #fff; padding: 5px 10px; border-radius: 4px;margin-left: 10px;"
                  >
                    EN
                    <!--{{ locale === 'zh' ? 'EN' : '中文' }}-->
                  </div>
                </div>
                <!-- 语言切换：俄语 -->
                <div class="head-menu-item lang-switch" @click="toggleLang3" v-if="locale !== 'ru'">
                  <div
                    class="title"
                    style="border: 1px solid #fff; padding: 5px 10px; border-radius: 4px;margin-left: 10px;"
                  >
                    RU<!--{{ locale === 'ru' ? '中文' : 'RU' }} -->
                  </div>
                </div>

              </div>
            </el-col>
        </el-row>
        <!-- v-if="isVisible" -->
        <div class="head-dialog" v-if="isVisible" @mouseenter="handleMouseEnter2" @mouseleave="handleMouseLeave">
          <!-- <div class="head-dialog-box">
                <el-tabs class="head-tabs" @tab-click="handleClick" v-if="isAbout == 'about'">
                  <el-tab-pane label="公司愿景" name="first"></el-tab-pane>
                  <el-tab-pane label="公司历程" name="second"></el-tab-pane>
                </el-tabs>
                <el-tabs class="head-tabs" @tab-click="handleClick2" v-if="isAbout== 'breeze'">
                    <el-tab-pane v-for="(item,index) in activeList" :label="item.title" :name="item.name" :key="index"></el-tab-pane>
                </el-tabs>
          </div> -->
          <el-row>
            <!--<el-col :span="6" v-if="locale == 'ru'"></el-col>-->
            <el-col :span="24">
              <div class="head-dialog-box">
                    <el-tabs class="head-tabs" @tab-click="handleClick" v-if="isAbout == 'about'">
                      <el-tab-pane class="head-tabs-item" :label="$t('header.vision')" name="first"></el-tab-pane>
                      <el-tab-pane class="head-tabs-item" :label="$t('header.history')" name="second"></el-tab-pane>
                    </el-tabs>
                    <el-tabs class="head-tabs" @tab-click="handleClick2" v-if="isAbout== 'breeze'">
                        <el-tab-pane class="head-tabs-item" v-for="(item,index) in activeList" :name="item.name" :key="index">
                          <template #label>
                            <span v-html="$t(item.titleKey)"></span>
                          </template>
                        </el-tab-pane>
                    </el-tabs>
              </div>
            </el-col>
          </el-row>
        </div>
        <div style="width:100%;height:99px;"></div>
      </div>
        
    </div>
</template>

<script setup lang="ts">
import { ref,reactive } from 'vue';
import logoSrc from '@/assets/image/logoIcon.webp';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';

const store = useStore();
const router = useRouter();
const { locale } = useI18n();

const toggleLang = () => {
  locale.value = locale.value === 'zh' ? 'zh' : 'zh';
  // Optionally save preference
  localStorage.setItem('user_locale', locale.value);
};
const toggleLang2 = () => {
  // 俄语 <-> 中文 之间切换
  locale.value = locale.value === 'en' ? 'en' : 'en';
  // Optionally save preference
  localStorage.setItem('user_locale', locale.value);
};
const toggleLang3 = () => {
  // 俄语 <-> 中文 之间切换
  locale.value = locale.value === 'ru' ? 'ru' : 'ru';
  // Optionally save preference
  localStorage.setItem('user_locale', locale.value);
};



const handleSelect = (key: string, keyPath: string[]) => {
  store.commit('setNavIndex',key)
  console.log(key, keyPath);
  console.log(store.commit('setNavIndex',key));
};
const isActive = ref(localStorage.getItem('navIndex') || 0);
const gotoPage = (url:string,index:number) => {
  console.log('gotoPage:',url,index);
  isActive.value = index;
  router.push(url)
}
const activeName=ref('first');
const handleClick = (tab: any, event: Event) => {
  console.log('hahah',tab.props.name, event);
  router.push({path:'/about',query:{name:tab.props.name}})
}
const isAbout = ref('');
const activeName2 = ref('one');
const activeList = reactive([
    {
        index: 0,
        titleKey: 'products.product_1',
        name: 'one'
    }, {
        index: 1,
        titleKey: 'products.product_2',
        name: 'two'
    }, {
        index: 2,
        titleKey: 'products.product_3',
        name: 'three'
    }
])
const handleClick2 = (tab: any, event: Event) => {
  console.log(tab, event,activeName2.value);
  router.push({path:'/breeze',query:{name:tab.props.name}})
};

const timer = ref(null);
const isVisible = ref(true);
const handleMouseEnter = (event: any) => {
  if(event){
    console.log('Mouse moved over tab', event,isVisible);
    if(event == 'about'){
      isAbout.value = 'about';
    }
    if(event == 'breeze'){
      isAbout.value = 'breeze';
    }
  } else {
    console.log(' tab', event,isVisible);
  }
  isVisible.value = true;
  // 在这里添加你的逻辑，比如改变样式等。
};
const handleMouseEnter2 = (event: any) => {
  console.log('......buxuyaoyincan',timer)
  isVisible.value = true;
  // 在这里添加你的逻辑，比如改变样式等。
};    


const handleMouseLeave = () => {
    isVisible.value = false;
  // 在这里添加你的逻辑，比如改变样式等。
}


// eslint-disable-next-line no-undef
const props = defineProps({
  data: String
})
console.log('props:',props)

</script>

<style lang="scss">

.head-logo{
  width: 50px;
}
.logo-title{
  font-size: 2.5em;
  font-weight: bold;
  margin-left: 20px;
}
.head-rows{
  // background-color: #fff;
    background-color: #000;
    color:#fff;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  // border-bottom: 1px solid var(--el-border-color-light);
  position: fixed;
  top: 0;
  z-index: 9999;
  .head-dialog{
    // display: none;
    position: absolute;
    top: 97px;
    left: 0;
    width: 100%;
    // height: 100px;
    transition: all .3s;
    background-color: #fff;
    background-color: #131718;
    color:#fff;
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
    // padding: 1.04167vw 0 2.91667vw;
    .head-dialog-box{
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      width: 1400px;
      .head-tabs{
        width: 100%;
        font-size: 1.5em;
        .head-tabs-item{
          padding: 0 50px;
        }
      }
    }
  }
}
.head-row-bg{
  height: 100px;
  width: 1400px;
  position: fixed;
  z-index: 9999;
  left: 50%;
  margin-left: -700px;
  .text-align{
    display: flex;
    align-items: center;
    cursor: pointer;
    // justify-content: center;
  }
}

.head-menus{
  position: relative;
  .head-menu{
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 990x;
    .head-menu-item{
      transition: none !important;
      padding: 0 50px;
      height: 99px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      .title{
        font-size: 1em !important;
        // 防止俄文过长时在头部自动换行导致样式错乱
        white-space: nowrap;
        word-break: keep-all;
      }
      &:hover{
        color: #FF5D07;
        // background-color: var(--el-menu-hover-bg-color);
        outline:none;
      }
    }
    .head-menu-item-active{
      color: #FF5D07;
    }
    .lang-switch{
      padding: 0;
      .title{
        min-width: 32px;
        height: 18px;
        font-size: 1em;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .login-btn{
      padding: 0 20px;
      margin-left: auto;
      .login-btn-title{
        padding: 6px 16px;
        border-radius: 20px;
        border: 1px solid #FF5D07;
        color: #FF5D07;
        font-size: 0.85em;
        white-space: nowrap;
        display: inline-block;
      }
    }
  }  
}
.about-tabs{
  height: 100px;
  width: 100%;
  background-color: #fff;
  position: fixed;
  z-index: 9999;
  top: 99px;
  .el-tabs__nav-wrap::after{
    background-color: #fff !important
  }
}
</style>

<style>
.el-menu--collapse .el-submenu__title .el-submenu__icon-arrow {
  display: none; /* 隐藏箭头 */
}
.el-submenu .el-menu { /* 调整二级菜单的样式 */
  border: none; /* 移除边框 */
}
.el-menu--vertical .el-menu--popup { /* 调整弹出菜单的样式 */
  min-width: 100px; /* 根据需要调整宽度 */
}
.el-menu--vertical .el-menu--popup .el-menu-item { /* 调整弹出菜单项的样式 */
  padding: 0 20px; /* 根据需要调整内边距 */
}
.el-popper.is-pure{
  display: block !important;
  width: 100%;
}
.head-rows .el-tabs__nav-wrap:after{
  background: transparent;
}
.head-rows .el-tabs__item:hover{
  color: #FF5D07;
}
.head-rows .el-tabs__item{
  color: #9e9e9e;
}
/* breeze 子菜单：靠左对齐，长文案单行展示并整体左移以保证可见性 */
.head-rows .head-dialog .head-tabs .el-tabs__nav{
  justify-content: flex-start;
}
.head-rows .head-dialog .head-tabs .el-tabs__item{
  white-space: nowrap;
  word-break: keep-all;
  line-height: 1.2;
  text-align: left;
  padding: 0 32px;
  max-width: none;
}
</style>
